export const WIX_APP_MARKET_TERMS_AND_CONDITIONS =
  'https://www.wix.com/about/app-market-terms';
